import { cn } from '../lib/utils';

import type { SVGProps } from 'react';

type AskableLogoProps = SVGProps<SVGSVGElement> & {
  className?: string;
};

export const AskableLogo = ({ className, ...props }: AskableLogoProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 58"
      fill="currentColor"
      className={cn('h-6 w-auto', className)}
      {...props}
    >
      <g fill="#dc3c4c" clipPath="url(#a)">
        <path
          fillRule="evenodd"
          d="M24.4 0c18.9 0 24.3 5.5 24.3 24.3q0 11.2-3.2 16.8A34 34 0 0 1 24.3 58v-9.3C5.4 48.6 0 43 0 24.3 0 5.3 5.5 0 24.4 0m-.1 20.2a4.9 4.9 0 1 1 0-9.8 4.9 4.9 0 0 1 0 9.8m0 3.3c4 0 10.6.8 10.6 4.9 0 4-4.4 8.9-10.6 8.9s-10.6-4.9-10.6-9 6.5-4.8 10.6-4.8"
          clipRule="evenodd"
        />
        <path d="M60.5 30.4c0-9.5 6.8-14.3 13-14.3a11 11 0 0 1 8 3l.8-2.4H90v27.4h-7.3l-1.2-2.7a10 10 0 0 1-8.3 3.4c-6.8 0-12.7-5.6-12.7-14.4m21.3 0c0-4.5-2.8-7.2-6.4-7.2s-6.5 2.8-6.5 7.2 2.8 7.2 6.5 7.2c3.6 0 6.4-2.8 6.4-7.2m12.6 7.1 6.2-2.8a6 6 0 0 0 5.1 3.7q3-.2 3-2.2.1-1.7-3.2-3l-3.5-1.3a8 8 0 0 1-6-8c0-4.6 4-7.9 9.4-7.9q7 0 9.2 5.1l-5.9 3.3a3 3 0 0 0-3-2.4q-1.9.1-2 1.7 0 1.4 1.8 2l3.7 1.3c4.3 1.6 7.1 4.2 7.1 9 0 5-4.2 8.8-10.9 8.8-6 0-9.6-3-11-7.3M120 5h8.4v20.9l7.7-9h10l-11.5 12.5L147 44h-10.6l-8-10.2V44h-8.3z" />
        <path d="M146 30.4c0-9.5 6.8-14.3 13-14.3a11 11 0 0 1 8 3l.8-2.4h7.7v27.4H168l-1.1-2.7a10 10 0 0 1-8.3 3.4c-6.8 0-12.7-5.6-12.7-14.4m21.3 0c0-4.5-2.8-7.2-6.4-7.2s-6.5 2.8-6.5 7.2 2.8 7.2 6.5 7.2c3.6 0 6.4-2.8 6.4-7.2M189.1 41l-1 3h-6.9V4.8h8.4v14.7a11 11 0 0 1 8.4-3.6c6.4 0 12.8 4.6 12.8 14.4 0 9.2-6.5 14.3-13.2 14.3A10 10 0 0 1 189 41m13.3-10.6c0-4.3-2.8-7.1-6.5-7.1s-6.5 2.7-6.5 7.1 2.8 7.1 6.5 7.1a6.6 6.6 0 0 0 6.5-7M214.1 5h8.3v39.2h-8.3zM242 44.8c-8.4 0-14.1-5.8-14.1-14.4s5.7-14.3 14-14.3c9.6 0 14 6.6 14 13.4q0 1.5-.3 3h-19.4a6 6 0 0 0 6.1 5.1 6 6 0 0 0 5.7-3.1l7 3.4c-2.5 4.3-6.8 6.9-13 6.9M236.4 27h11a5 5 0 0 0-5.5-4.6 5.3 5.3 0 0 0-5.5 4.6" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h256v58H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
